// Note from Jen: Javascript for Announcement Bar

document.addEventListener('DOMContentLoaded', function() {
  const messages = document.querySelectorAll('.announcement-text');
  let currentIndex = 0;

  function rotateMessages() {
    // Hide the current message
    messages[currentIndex].classList.remove('active');
    
    // Update the index (looping back to the first message)
    currentIndex = (currentIndex + 1) % messages.length;

    // Show the next message
    messages[currentIndex].classList.add('active');
  }

  setInterval(rotateMessages, 4000); // Change every 8 seconds
  rotateMessages(); // Show the first message on load
});